import * as React from "react";
import update = require("react-addons-update");

import DarienSqlStore from "../../stores/DarienSqlStore";
import { DarienSqlAction } from "../../actions/DarienSqlActions";
import { ResidentVerification } from "./Models";

export interface VerifyIdentityProps
{
	verificationCallback: (state: ResidentVerification) => void;
}

export interface VerifyIdentityState
{
	residentIsValid?: boolean;
	lastName: string;
	licensePlateNumbers?: Array<string>;
}

export class VerifyIdentity extends React.Component<VerifyIdentityProps, VerifyIdentityState>
{
	state: VerifyIdentityState =
	{
		residentIsValid: null,
		lastName: "",
		licensePlateNumbers: []
	}

	componentWillMount(): void
	{
		DarienSqlStore.addListener(this.darienSqlStoreChanged.bind(this));
	}

	private darienSqlStoreChanged()
	{
		var result = DarienSqlStore.fetchResident();
		if (result)
		{
			var allPlatesVerified = true;

			for (var i = 0; i < result.PlatesVerified.length; i++)
			{
				if (!result.PlatesVerified[i].IsVerified)
				{
					allPlatesVerified = false;
					break;
				}
			}

			this.setState(update(this.state, { $set: { residentIsValid: allPlatesVerified} }));
			if (allPlatesVerified)
			{
				
				this.props.verificationCallback(result);
			}
		}

	}

	constructor(props: VerifyIdentityProps, context: any)
	{
		super(props, context);
		this.runVerification = this.runVerification.bind(this);
	}

	render()
	{
		return <div className="panel panel-default">
			<div className="panel-heading">
				<h3>Residence Verification</h3>
			</div>
			{ this.renderAlert() }
			<div className="panel-body">
				<div className="form-group">
					<label htmlFor="lastName">Last Name</label>
					<input type="text" className="form-control" id="lastName" placeholder="Smith" onChange={(evt: React.FormEvent<any>) =>
                    {
						this.setState(update(this.state, { $set: { lastName: evt.target.value } }));
                    } }/>
				</div>
				<div className="form-group">
					<label htmlFor="licensePlateNumber">License Plate Number: 1</label>
					<input type="text" className="form-control" id="licensePlateNumber" placeholder="123ABC" onChange={
						(evt: React.FormEvent<any>) =>
						{
							this.setLicensePlate(0, evt.target.value as string);
						} }/>
				</div>
				<div className="form-group">
					<label htmlFor="licensePlateNumber2">License Plate Number: 2 <i>(optional) </i></label>
					<input type="text" className="form-control" id="licensePlateNumber2" placeholder="123ABC" onChange={
						(evt: React.FormEvent<any>) =>
						{
							this.setLicensePlate(1, evt.target.value as string);
						} }/>
				</div>
				<div className="form-group">
					<label htmlFor="licensePlateNumber3">License Plate Number: 3 <i>(optional) </i></label>
					<input type="text" className="form-control" id="licensePlateNumber3" placeholder="123ABC" onChange={
						(evt: React.FormEvent<any>) =>
						{
							this.setLicensePlate(2, evt.target.value as string);
						} }/>
				</div>
				<button className="btn btn-primary pull-right" id="verifyResident" onClick={ this
					.runVerification }>Search...</button>
			</div>
		</div>;
	}
	private setLicensePlate(index: number, plate: string)
	{
		var plates = this.state.licensePlateNumbers;
		plates[index] = plate;
		this.setState(update(this.state, { $set: { licensePlateNumbers: plates } }));
	}
	private renderAlert()
	{
		if (this.state.residentIsValid != null && !this.state.residentIsValid)
		{
			return <div className="bg-warning verificationWarning">
				<h4>
					<p>We are sorry, but we could not verify your residency status with the provided information.</p>
					<p>
						Please check your information and try again.If you receive this message repeatedly, please call
						(203) 656-7346 for further assistance.
					</p>
				</h4>
			</div>;
		}
	}

	private runVerification()
	{
		DarienSqlStore.verifyResidency(this.state.lastName, this.state.licensePlateNumbers);
	}
}


// WEBPACK FOOTER //
// ./src/components/darien/VerifyIdentity.tsx